/* eslint-disable no-unused-vars */
const Autodesk = window.Autodesk;
import store from '@/store';
import { removeFromScene, pointerToRaycaster, createTextGl, addToScene } from '../utils/forgeUtils'
import { convexHull } from '../utils/geometryUtils'
import { disposeArea2d, drawArea2d, drawPolygon, drawLine } from '../utils/threejsUtils'
import { ForgeEquipment, ForgeScaffold, ForgeAnnotation, ForgeInspection } from './../scripts/js/forgeModels';
import { getAMISTagById } from '@/utils/amisAPIs'
import config from '../../appConfig'
const THREE = window.THREE;
import { ShapeUtils } from './../utils/ShapeUtils';
import { isInsidePoly } from './../utils/geometryUtils';

class Plan2DExtension extends Autodesk.Viewing.Extension {

    constructor(loadedViewer, options) {
        super(loadedViewer, options);
        this.viewer = loadedViewer;
        this.points;
        this.directionMesh;
        this.directionMaterial;
        this.directionGeom;

        this.webGLDOM = this.viewer.canvas.parentElement.parentElement.parentElement;
        let _this = this;
        this.webGLDOM.addEventListener("click", (event) => {
            _this.onMouseUp(event);
        });
        this.viewer.canvas.addEventListener("mousedown", (event) => {
            _this.onMouseDown(event);
        });
        this.webGLDOM.addEventListener("mousemove", (event) => {
            _this.onMouseMove(event);
        }, false);
        let isFirefox = (/Firefox/i.test(navigator.userAgent));
        var mousewheelevt = isFirefox ? "DOMMouseScroll" : "mousewheel";
        this.viewer.canvas.addEventListener(mousewheelevt, (event) => {
            //to fix Forge issue with method setZoomInLimitFactor()
            let camera = _this.viewer.getCamera();
            if (event.wheelDelta > 0 && camera.position.z > .02) {
                _this.viewer.navigation.setPosition(new THREE.Vector3(camera.position.x, camera.position.y, camera.position.z - .01))
            }
        }, false);
        this.sceneName = 'area-scene';
        this.measuringAreaOn = false;
        this.areaTextClass = 'floating-area-text';

        this.minAreaLineLength = .003;

        this.area2d = null;
        this.areaPoints = [];
        this.measuringDone = true;
        this.mouseEvent;

        this.tagToAddAreaTo = null;

        this.pinClassName = 'pinned-point-3d'
    }
    load() {
        if (store.state.forgeService.pointToZoomToIn2d) {
            store.state.forgeService.zoomToPoint2D(store.state.forgeService.pointToZoomToIn2d);
            store.state.forgeService.pointToZoomToIn2d = null;
        }
        store.state.forgeService.updateAll2DIcons();
        this.updatePinPoint()

        var _this = this;
        this.viewer.addEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, () => {
            store.state.forgeService.updateLabelsPositionsByClassName(this.pinClassName, this.viewer)
            _this.updateAreaText();
            store.state.forgeService.toggleCrossHairCursorToViewer(!!store.state.isPickingPin, this.viewer)
        });
        document.addEventListener("keydown", this.onKeyDown);
        this.viewer.canvas.addEventListener('mouseup', (evt) => {
            _this.mouseEvent = { x: evt.offsetX, y: evt.offsetY };
            if (!store.state.forgeService)
                return;
            //focus on left click only
            if (evt.which != 1)
                return;

            let isPickingTag = store.state.isPickingTag;
            let isPickingSubTag = store.state.isPickingSubTag;
            let isPickingPin = store.state.isPickingPin;

            if (isPickingTag || isPickingSubTag || isPickingPin) {
                if (!store.state.selectedLevel || !store.state.selectedLevel.hasAllMappingInfo()) {
                    store.dispatch({ type: "alert_Forge", message: 'Please finish mapping 2d/3d in admin first.' })
                    return;
                }

                var hitTest = _this.viewer.clientToWorld(evt.offsetX, evt.offsetY, true);
                if (!hitTest || !hitTest.point)
                    return;

                let worldPt = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(hitTest.point);
                if (isPickingTag)
                    store.state.forgeService.addNewTag("2d", worldPt, store.state.selectedLevel.name, false);
                else if (isPickingSubTag)
                    store.state.forgeService.addSubInspection(worldPt);
                else if (isPickingPin) {
                    store.state.pinnedPoint2d = hitTest.point
                    this.updatePinPoint()
                }
                store.commit('setIsPickingPin', false);
                store.commit('setIsPickingTag', false)
                store.state.forgeService._isPickingAnnotation_Create = false;
            }
        });
        this.viewer.navigation.setZoomOutLimitFactor(10);

        this.viewer.registerContextMenuCallback('reality-context-menu-2d', (menu, status) => {
            menu.push({
                title: 'Add Tag',
                target: () => {

                    var hitTest = _this.viewer.clientToWorld(_this.mouseEvent.x, _this.mouseEvent.y, true);
                    if (!hitTest || !hitTest.point)
                        return;
                    let worldPt = store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(hitTest.point);
                    store.state.forgeService.addNewTag("2d", worldPt, store.state.selectedLevel.name, false);
                }
            });
        });
        return true;
    }
    unload() {
        document.removeEventListener("keydown", this.onKeyDown);
        return true;
    }
    onToolbarCreated() {

    }
    deactivate() {
        this.stopMeasuring();
        this.clearDimensions();
    }
    stopMeasuring() {
        this.measuringAreaOn = false;
        this.measuringDone = true;
    }
    clearDimensions() {
        store.state.forgeService.clearElementsByClassName(this.areaTextClass);
        this.areaPoints = [];
        disposeArea2d(this.area2d, this.viewer, this.sceneName)
        this.viewer.impl.invalidate(false, false, true);
    }
    drawDirection2D() {
        if (!this.viewer || 
            !this.viewer.model || 
            !store.state.viewer || 
            !store.state.viewer.model || 
            !store.state.selectedLevel || 
            !store.state.selectedLevel.hasAllMappingInfo()) return;
            
        if (!this.viewer.overlays.hasScene('direction2D-scene')) {
            this.viewer.overlays.addScene('direction2D-scene');
        }
        if (this.directionMesh) {
            this.directionGeom.dispose();
            this.directionMaterial.dispose();
            this.viewer.overlays.removeMesh(this.directionMesh, 'direction2D-scene');
        }

        if (!store.state.selectedLevel || !store.state.selectedLevel.mappingViewersPointsInfo)
            return;
        var vector = store.state.viewer.navigation.getCamera().getWorldDirection();
        //get global position in meters
        var position = store.state.forgeService.view3dToWorld(store.state.viewer.navigation.getPosition())
        var point = store.state.selectedLevel.mappingViewersPointsInfo._3dTo2d(position);

        vector = vector.normalize().multiplyScalar(.05);
        var normalVec = new THREE.Vector2(-vector.y, vector.x);
        var pt1 = point.clone().add(vector).add(normalVec);
        var pt2 = point.clone().add(vector).add(normalVec.clone().negate());
        var bz1 = pt1.clone().add(vector);
        var bz2 = pt2.clone().add(vector);
        const heartShape = new THREE.Shape();
        heartShape.moveTo(pt1.x, pt1.y);
        heartShape.moveTo(point.x, point.y);
        heartShape.moveTo(pt2.x, pt2.y);
        heartShape.bezierCurveTo(bz2.x, bz2.y, bz1.x, bz1.y, pt1.x, pt1.y);

        this.directionGeom = new THREE.ShapeGeometry(heartShape);
        var color = store.state.selectedLevel.containsElevation(position.z) ? 0X6fcd3b : 0X8CCECD;
        this.directionMaterial = new THREE.MeshBasicMaterial({ color: color, opacity: 0.5, transparent: true });
        this.directionMesh = new THREE.Mesh(this.directionGeom, this.directionMaterial);
        this.directionMesh.position.setZ(.01);
        this.viewer.overlays.addMesh(this.directionMesh, 'direction2D-scene');
        this.viewer.impl.invalidate(true, true, true);

        // if (this.directionGeom) {
        //     // this.directionMesh.position.set(new THREE.Vector3(point.x, point.y, 3));

        //     // this.directionGeom.vertices = heartShape.getPoints().map(o=>new THREE.Vector3(o.x,o.y,3));
        //     var newPoints = heartShape.getPoints().map(o => new THREE.Vector2(o.x, o.y)).reverse();
        //     for (var i = 0; i < newPoints.length; i++) {
        //         this.directionGeom.vertices[i].set(newPoints[i].x, newPoints[i].y, 3);
        //     }
        //     this.directionGeom.verticesNeedUpdate= true;
        //     this.viewer.impl.invalidate(true,true,true);
        // } else {
        //     this.directionGeom = new THREE.ShapeGeometry(heartShape);
        //     this.directionMaterial = new THREE.MeshBasicMaterial({ color: 0x8080 ,opacity:0.5});
        //     this.directionMesh = new THREE.Mesh(this.directionGeom, this.directionMaterial);
        //     this.directionMesh.position.setZ(3);
        //     this.viewer.overlays.addMesh(this.directionMesh, 'direction2D-scene');
        // }
        return;


        // const geometry = new THREE.Geometry()

        // geometry.vertices.push(new THREE.Vector3(.5, 0.5, 3))
        // geometry.vertices.push(new THREE.Vector3(1, 1, 3))
        // geometry.vertices.push(new THREE.Vector3(0.5, 0.5, 3))
        // geometry.vertices.push(new THREE.Vector3(0.5, .1, 3))

        // var linesMaterial = new THREE.LineBasicMaterial({
        //     color: new THREE.Color(0xFF0000),
        //     transparent: true,
        //     depthWrite: false,
        //     depthTest: true,
        //     linewidth: 50,
        //     opacity: 1.0
        // })

        // var lines = new THREE.Line(geometry,linesMaterial,THREE.LinePieces)
        // this.viewer.impl.createOverlayScene('myOverlay', linesMaterial)

        // this.viewer.impl.addOverlay('myOverlay', lines)

        // geom.vertices[1].set(.3,.3,0)
        // geom.verticesNeedUpdate= true;
        // this.viewer.impl.invalidate(true,true,true);
    }
    updatePolygonGl() {
        let color = this.isDrawingAreaToDownloadPC() ? 0x53ff53 : 0xFF0000
        disposeArea2d(this.area2d, this.viewer, this.sceneName)
        this.area2d = drawArea2d(this.areaPoints, this.viewer, this.sceneName, color)
        this.viewer.impl.invalidate(false, false, true);
        this.updateAreaText();
    }   
    updateAreaText() {
        store.state.forgeService.clearElementsByClassName(this.areaTextClass);
        if (this.isPickingTagArea() || this.isDrawingAreaToDownloadPC())
            return;
        if (store.state.selectedLevel && store.state.selectedLevel.mappingViewersPointsInfo
            && store.state.selectedLevel.mappingViewersPointsInfo.isReady() && this.areaPoints.length > 0) {
            let center = new THREE.Box2().setFromPoints(this.areaPoints).getCenter();
            center = new THREE.Vector3(center.x, center.y, 0);
            // let facesIndexes = ShapeUtils.triangulateShape(this.areaPoints,[]);
            let globalPoints = this.areaPoints.map(o => store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(o));
            let area = ShapeUtils.area(globalPoints).toFixed(2);
            if (area < 0)
                area *= -1;
            var unit = !store.state.viewer || !store.state.viewer.model ? 'm²' : store.state.viewer.model.getDisplayUnit() + '²';
            area = area + ' ' + unit;

            var iconOptions = {
                position: center,
                differences: null,
                title: area,
                id: '',
                className: this.areaTextClass,
                forgeViewer: this.viewer,
                onClick: () => { },
                addContent: true
            }
            store.state.forgeService.create3DIconToViewer(iconOptions);
            store.state.forgeService.updateLabelsPositionsByClassName(this.areaTextClass, this.viewer)
        }
    }
    updatePinPoint() {
        var point = store.state.pinnedPoint2d
        store.state.forgeService.clearElementsByClassName(this.pinClassName)
        if (point) {
            var iconOptions = {
                position: point,
                differences: null,
                title: '',
                id: '',
                className: this.pinClassName,
                forgeViewer: this.viewer,
                onClick: () => { },
                addContent: false
            }
            store.state.forgeService.create3DIconToViewer(iconOptions);
            store.state.forgeService.updateLabelsPositionsByClassName(this.pinClassName, this.viewer)
        }
        store.state.forgeService.toggleCrossHairCursorToViewer(false, this.viewer)
        this.viewer.impl.invalidate(true, true, true)
    }
    closeAreaPoints() {
        if (!this.measuringDone && this.areaPoints.length > 3) {
            this.measuringDone = true;
            this.measuringAreaOn = false;
            this.areaPoints[this.areaPoints.length - 1] = this.areaPoints[0];
            this.updatePolygonGl();
            store.commit("SET_IS_MEASUREING_AREA", false);
        }
    }
    toggleMeasuringArea(measureOn) {
        store.commit("SET_IS_MEASUREING_AREA", measureOn);
        this.measuringAreaOn = measureOn;
        this.areaPoints = [];
        if (!measureOn)
            this.deactivate();
    }
    setTagToAddAreaTo(tag) {
        this.tagToAddAreaTo = tag;
        this.toggleMeasuringArea(true);
    }
    setDrawingMode(drawingOn) {
        this.measuringAreaOn = drawingOn;
        this.areaPoints = [];
        if (!drawingOn)
            this.deactivate();
    }
    isPickingTagArea() {
        return this.tagToAddAreaTo && (store.getters['GET_ADDING_TAG_INFO'] || store.getters['GET_EDITING_AMIS_TAG'] || store.getters['GET_EDITING_TAG'])
    }
    isDrawingAreaToDownloadPC() {
        return store.getters["getIsDrawingAreaToDownloadPC"];
    }
    addAreaToTag() {
        let worldPoints = this.areaPoints.map(o => store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(o))
        let tagPoint = this.tagToAddAreaTo.getGlobalPoint()
        if (isInsidePoly(tagPoint, worldPoints))
            this.tagToAddAreaTo.area2dPoints = worldPoints
        else
            store.dispatch({ type: "alert_Forge", message: 'Area does not contain tag point.' })
        this.tagToAddAreaTo = null;
        this.deactivate();
        store.state.forgeService.updateAll2DIcons();
    }
    processDownloadPC() {
        let worldPoints = this.areaPoints.map(o => store.state.selectedLevel.mappingViewersPointsInfo._2dTo3d(o));
        store.state.forgeService.sendDataToDownloadPointCloudTab(worldPoints);
    }
    onKeyDown = (event) => {
        if (event.keyCode === 13) {
            if (this.measuringAreaOn) {
                this.closeAreaPoints();
                if (this.isPickingTagArea())
                    this.addAreaToTag()
                else if (this.isDrawingAreaToDownloadPC())
                    this.processDownloadPC()
            }
        } else if (event.keyCode === 27) {
            this.deactivate();
            store.commit("SET_IS_MEASUREING_AREA", false);
        }
    }
    onMouseMove(mouse) {
        if (!this.measuringAreaOn || !this.viewer.impl)
            return;
        if (!this.dragged) {
            this.dragged = true;
            return;
        }
        let mouseWorld = this.viewer.clientToWorld(mouse.offsetX, mouse.offsetY, true, true);
        if (!mouseWorld)
            return;
        mouseWorld = mouseWorld.point;
        if (!this.measuringDone && this.areaPoints.length > 0) {
            if (this.areaPoints[0].distanceTo(mouseWorld) < this.minAreaLineLength)
                this.areaPoints[this.areaPoints.length - 1] = this.areaPoints[0];
            else
                this.areaPoints[this.areaPoints.length - 1] = mouseWorld;
            this.updatePolygonGl();
        }
    }
    onMouseDown(mouse) {
        if (mouse.which != 1)
            return;
        this.dragged = false;
    }
    onMouseUp(mouse) {
        if (mouse.which != 1 || !this.measuringAreaOn)
            return;
        if (this.dragged)
            return;
        let mouseWorld = this.viewer.clientToWorld(mouse.offsetX, mouse.offsetY, true, true);
        if (!mouseWorld)
            return;
        mouseWorld = mouseWorld.point;

        if (!this.measuringDone) {
            if (this.areaPoints[0].distanceTo(mouseWorld) < this.minAreaLineLength) {
                this.measuringDone = true;
                this.measuringAreaOn = false;
                store.commit("SET_IS_MEASUREING_AREA", false);

                if (this.isPickingTagArea())
                    this.addAreaToTag()
                else if (this.isDrawingAreaToDownloadPC())
                    this.processDownloadPC()
            }
            else
                this.areaPoints.push(mouseWorld);
        } else {
            this.areaPoints = [mouseWorld, mouseWorld.clone()];
            this.measuringDone = false;
        }
        this.updatePolygonGl();
    }
}
Autodesk.Viewing.theExtensionManager.registerExtension('Plan2DExtension', Plan2DExtension)
